
// 货品一览
import request from '@/utils/request'

// 获取货品品牌
export function GetBrandList(data) {
  return request({
    url: 'Product/GetBrandList',
    method: 'get',
    params: data
  })
}
// 获取货品档案

export function GetProductProfileList(data) {
  return request({
    url: 'Product/GetProductProfileList',
    method: 'get',
    params: data
  })
}
// 保存

export function SaveBrandInfo(data) {
  return request({
    url: 'Product/SaveBrandInfo',
    method: 'post',
    data: data
  })
}
// 获取履历

export function GetHistoryByOperation(data) {
  return request({
    url: 'Product/GetHistoryByOperation',
    method: 'get',
    params: data
  })
}

// 保存货品档案
export function SaveProductProfileInfo(data) {
  return request({
    url: 'Product/SaveProductProfileInfo',
    method: 'post',
    data: data
  })
}

// 获取商品标签
export function GetProductLabelList(data) {
  return request({
    url: 'Product/GetProductLabelList',
    method: 'get',
    params: data
  })
}
// 根据标签获取商品列表
export function GetProductListByLabels(data) {
  return request({
    url: 'Product/GetProductListByLabels',
    method: 'get',
    params: data
  })
}
// 根据标签获取商品列表
export function ShopProductPriceList(data) {
  return request({
    url: 'Product/ShopProductPriceList',
    method: 'get',
    params: data
  })
}
// 保存货品档案
export function SaveShopProductPriceInfo(data) {
  return request({
    url: 'Product/SaveShopProductPriceInfo',
    method: 'post',
    data: data
  })
}
// 商品价格的上传提交
export function ImportXlsFileForShopPriceSetup(data) {
  return request({
    url: 'Product/ImportXlsFileForShopPriceSetup',
    method: 'post',
    data: data
  })
}
// 货品档案 确认
export function ConfirmWarehouseChange(data) {
  return request({
    url: 'Product/ConfirmWarehouseChange',
    method: 'post',
    data: data
  })
}
// 出库仓设置未匹配查询
export function GetNotMatchWarehouseData(data) {
  return request({
    url: 'Warehouse/GetNotMatchWarehouseData',
    method: 'get',
    params: data
  })
}
// 新增商品编码
export function AddProductCode(data) {
  return request({
    url: 'Warehouse/AddProductCode',
    method: 'get',
    params: data
  })
}
// 出库仓设置未匹配导出
export function ExportNotMatchWarehouseData(data) {
  return request({
    url: 'Warehouse/ExportNotMatchWarehouseData',
    method: 'get',
    params: data
  })
}

// 一级分类查询
export function GetStair(data) {
  return request({
    url: 'Product/GetStair',
    method: 'get',
    params: data
  })
}

// 二级分类查询
export function GetSecond(data) {
  return request({
    url: 'Product/GetSecond',
    method: 'get',
    params: data
  })
}

// 财务1/2级分类获取下拉
export function GetFinancialCategory(data) {
  return request({
    url: 'Product/GetFinancialCategory',
    method: 'get',
    params: data
  })
}

// 财务二级分类  不联动
export function GetFinancialSecondCategory(data) {
  return request({
    url: 'Product/GetFinancialSecondCategory',
    method: 'get',
    params: data
  })
}

//  反查询业务分类
export function GetCategoryByFinancialCategory(data) {
  return request({
    url: 'Product/GetCategoryByFinancialCategory',
    method: 'get',
    params: data
  })
}

// 新增一级业务分类
export function AddOneLevelCategory(data) {
  return request({
    url: 'Product/AddOneLevelCategory',
    method: 'post',
    data: data
  })
}

// 新增一级财务分类
export function AddOneLevelFinancialCategory(data) {
  return request({
    url: 'Product/AddOneLevelFinancialCategory',
    method: 'post',
    data: data
  })
}

// 编辑一级分类
export function EditOneLevelCategory(data) {
  return request({
    url: 'Product/EditOneLevelCategory',
    method: 'post',
    data: data
  })
}

// 编辑一级财务分类
export function EditOneLevelFinancialCategory(data) {
  return request({
    url: 'Product/EditOneLevelFinancialCategory',
    method: 'post',
    data: data
  })
}

// 新增二级分类
export function AddCategory(data) {
  return request({
    url: 'Product/AddCategory',
    method: 'post',
    data: data
  })
}

// 新增二级财务分类
export function AddFinancialCategory(data) {
  return request({
    url: 'Product/AddFinancialCategory',
    method: 'post',
    data: data
  })
}
// 编辑二级分类
export function EditCategory(data) {
  return request({
    url: 'Product/EditCategory',
    method: 'post',
    data: data
  })
}

// 编辑二级财务分类
export function EditFinancialCategory(data) {
  return request({
    url: 'Product/EditFinancialCategory',
    method: 'post',
    data: data
  })
}
// 删除分类
export function DelClassificationById(data) {
  return request({
    url: 'Product/DelClassificationById',
    method: 'post',
    data: data
  })
}

// 删除财务分类
export function DelFinancialCategoryById(data) {
  return request({
    url: 'Product/DelFinancialCategoryById',
    method: 'post',
    data: data
  })
}
// 查询业务分类
export function GetCategoryListByCondition(data) {
  return request({
    url: 'Product/GetCategoryListByCondition',
    method: 'get',
    params: data
  })
}

// 查询财务分类
export function GetFinancialCategoryListByCondition(data) {
  return request({
    url: 'Product/GetFinancialCategoryListByCondition',
    method: 'get',
    params: data
  })
}

// 查询有数据效期日期列表
export function GetStatisticDate(data) {
  return request({
    url: 'warehouse/GetStatisticDate',
    method: 'get',
    params: data
  })
}
// 推送分类信息
export function PushFinancialCategoryToNc(data) {
  return request({
    url: 'NcPushData/PushFinancialCategoryToNc',
    method: 'post',
    data: data
  })
}
// 审核分类
export function FinancialCategoryApproval(data) {
  return request({
    url: 'NcPushData/FinancialCategoryApproval',
    method: 'post',
    data: data
  })
}

// 推送商品信息
export function PushProductInfoToNc(data) {
  return request({
    url: 'NcPushData/PushProductInfoToNc',
    method: 'post',
    data: data
  })
}
// 审核商品
export function ProductServiceCategoryApproval(data) {
  return request({
    url: 'NcPushData/ProductServiceCategoryApproval',
    method: 'post',
    data: data
  })
}

// 设为爆款
export function SetAsHotProduct(data) {
  return request({
    url: 'Product/SetAsHotProduct',
    method: 'post',
    data: data
  })
}
// 导出
export function ExportProductPriceList(data) {
  return request({
    url: 'Product/ExportProductPriceList',
    method: 'get',
    params: data
  })
}
// 查询组合活动列表
export function GetShopActivitiesList(data) {
  return request({
    url: 'CollectionDiscount/GetShopActivitiesList',
    method: 'get',
    params: data
  })
}
// 删除组合活动
export function DeleteShopActivity(data) {
  return request({
    url: 'CollectionDiscount/DeleteShopActivity',
    method: 'post',
    data: data
  })
}
// 保存组合活动
export function SaveShopActivity(data) {
  return request({
    url: 'CollectionDiscount/SaveShopActivity',
    method: 'post',
    data: data
  })
}

// 商品列表-修改-加载cfda下拉框
export function GetCfdaList(data) {
  return request({
    url: 'Product/GetCfdaList',
    method: 'get',
    params: data
  })
}

// cfda校验批准文号
export function CheckCfda(data) {
  return request({
    url: 'Product/CheckCfda',
    method: 'get',
    params: data
  })
}

// 新增cfda数据源
export function AddCfdaByProduct(data) {
  return request({
    url: 'Product/AddCfdaByProduct',
    method: 'post',
    data: data
  })
}

// 保存SPU信息
export function SaveProductSPU(data) {
  return request({
    url: 'erp/ProductSPU/SaveProductSPU',
    method: 'post',
    data: data
  })
}

// 删除SPU
export function DelProductSPU(data) {
  return request({
    url: 'erp/ProductSPU/DelProductSpu',
    method: 'post',
    data: data
  })
}

// 禁用/恢复 SPU
export function SetSPU(data) {
  return request({
    url: 'ProductSPU/SetSPU',
    method: 'post',
    data: data
  })
}

// 效验上代SPU
export function CheckBeforeSPUNo(data) {
  return request({
    url: 'erp/ProductSPU/CheckBeforeSpuNo',
    method: 'post',
    data: data
  })
}

// 远程搜索上代spu编码
export function GetSpuNo(data) {
  return request({
    url: 'erp/ProductSPU/GetSpuNo',
    method: 'get',
    params: data
  })
}

// GetList
export function GetList(data) {
  return request({
    url: 'erp/Query/GetPageList',
    method: 'post',
    data: data
  })
}
// 编辑-查询锁定字段内容(xx正在编辑部分)
export function GetChangeApplyEditFiled(data) {
  return request({
    url: 'erp/ChangeApplyOrder/GetChangeApplyEditFiled',
    method: 'get',
    params: data
  })
}
// 查询当前变更字段(红字部分)
export function GetChangeApplyCurrentFiled(data) {
  return request({
    url: 'erp/ChangeApplyOrder/GetChangeApplyCurrentFiled',
    method: 'get',
    params: data
  })
}
// 财务分类(根据最明细的业务分类id)
export function GetFinancialClass(data) {
  return request({
    url: 'Product/GetFinancialClass',
    method: 'get',
    params: data
  })
}

// 财务分类(根据最明细的业务分类id)---新接口
export function GetFinancialPropertyTree(data) {
  return request({
    url: 'erp/MainData/GetFinancialPropertyTree',
    method: 'get',
    params: data
  })
}

// 根据业务分类获取财务分类(根据最明细的业务分类id)---新接口
export function GetFinancialPropertyByPropertyId(data) {
  return request({
    url: 'erp/MainData/GetFinancialPropertyByPropertyId',
    method: 'get',
    params: data
  })
}

// 获取上代sku编码
export function GetSkuNo(data) {
  return request({
    url: 'erp/ProductSku/GetSkuNo',
    method: 'get',
    params: data
  })
}

// 获取spu编码
export function GetSpu(data) {
  return request({
    url: 'erp/ProductSpu/GetList',
    method: 'get',
    params: data
  })
}

// 产品系列下拉
export function GetSeries(data) {
  return request({
    url: 'erp/ProductSeries/GetSeries',
    method: 'get',
    params: data
  })
}
// 获取当前用户该原单对应的草稿变更单数量
export function GetCurrentUserDraftChangeApplyCount(data) {
  return request({
    url: 'erp/ChangeApplyOrder/GetCurrentUserDraftChangeApplyCount',
    method: 'get',
    params: data
  })
}
// 获取禁用是否可用
export function GetSkuDisableAvailable(data) {
  return request({
    url: 'erp/ProductSku/GetDisableAvailable',
    method: 'get',
    params: data
  })
}
// sku校验(提交审批)
export function ValidateSku(data) {
  return request({
    url: 'erp/ProductSku/Validate',
    method: 'post',
    data: data
  })
}
// 品牌是否关联sku
export function IsRelatedSku(data) {
  return request({
    url: 'erp/Brand/IsRelatedSku',
    method: 'get',
    params: data
  })
}
// 品牌是否关联sku
export function IsExistNotFinalDisableChangeApply(data) {
  return request({
    url: 'erp/ChangeApplyOrder/IsExistNotFinalDisableChangeApply',
    method: 'get',
    params: data
  })
}
// 物料MRP主数据可选取物料
export function GetMaterialMrpProducts(data) {
  return request({
    url: 'erp/Common/GetMaterialMrpProducts',
    method: 'get',
    params: data
  })
}
// 工厂数据
export function GetFactory(data) {
  return request({
    url: '/erp/Common/GetFactory',
    method: 'get',
    params: data
  })
}
// 更新库存看板数据
export function ExectInventoryStockReportList(data) {
  return request({
    url: '/erp/SalePredict/ExectInventoryStockReportList',
    method: 'get',
    params: data
  })
}

/**
 *  2023/06/07  主数据分类管理增加四级分类迭代
 */

// 停用分类
export function DisabledCategory(data) {
  return request({
    url: 'Product/DisabledCategory',
    method: 'post',
    data: data
  })
}

//  恢复分类
export function RecoverCategory(data) {
  return request({
    url: 'Product/RecoverCategory',
    method: 'post',
    data: data
  })
}

// 生产商下拉数据源
export function ProviderGetList(data) {
  return request({
    url: '/erp/Provider/GetList',
    method: 'get',
    params: data
  })
}

// 基本单位的下拉数据源
export function GetUnitList(data) {
  return request({
    url: 'erp/ProductSku/GetUnitList',
    method: 'get',
    params: data
  })
}

// 货品类型的下拉数据源
export function GetCategoryTypeList(data) {
  return request({
    url: 'erp/ProductSku/GetCategoryTypeList',
    method: 'get',
    params: data
  })
}

export function GetBomForMrpMaterial(data) {
  return request({
    url: 'erp/PLM/GetBomForMrpMaterial',
    method: 'get',
    params: data
  })
}

// 导入sku明细
export function ImportSku(data) {
  return request({
    url: 'erp/ProductSku/ImportSku',
    method: 'post',
    data: data
  })
}

// 新增sku权限字段
export function GetFieldPermissions(data) {
  return request({
    url: 'erp/Query/GetFieldPermissions',
    method: 'post',
    data: data
  })
}

// --------------------------采购分类管理--------------------------

// 新增分类
export function AddPurchaseCategory(data) {
  return request({
    url: 'Product/AddPurchaseCategory',
    method: 'post',
    data: data
  })
}
// 编辑分类
export function EditPurchaseCategory(data) {
  return request({
    url: 'Product/EditPurchaseCategory',
    method: 'post',
    data: data
  })
}
// 停用分类
export function DisabledPurchaseCategory(data) {
  return request({
    url: 'Product/DisabledPurchaseCategory',
    method: 'post',
    data: data
  })
}
// 恢复分类
export function RecoverPurchaseCategory(data) {
  return request({
    url: 'Product/RecoverPurchaseCategory',
    method: 'post',
    data: data
  })
}

// 列表查询
export function GetPurchaseCategoryListByCondition(data) {
  return request({
    url: 'Product/GetPurchaseCategoryListByCondition',
    method: 'get',
    params: data
  })
}

// 下拉查询
export function GetPurchaseSecond(data) {
  return request({
    url: 'Product/GetPurchaseSecond',
    method: 'get',
    params: data
  })
}

// 导入inci表
export function ImportINCI(data) {
  return request({
    url: 'erp/Inci/Import',
    method: 'post',
    data: data
  })
}
